import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, ErrorStateMatcher } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { BlurInputErrorMatcher } from '../../../../modules/material/material.errror';
import { Countries, countries } from '../../../../model/countries';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
@Component({
  selector: 'hybse-admin-edit-user-info',
  templateUrl: './edit-user-info.component.html',
  styleUrls: ['./edit-user-info.component.css']
})
export class EditUserInfoComponent implements OnInit {
  public formGroup: FormGroup;
  public userDetails: any;
  public genders: string[] = ['Male', 'Female'];
  public localeNames: string[] = ['English', 'German'];
  public confirmPassword: string;
  public message: string;
  countryList: Countries[] = countries;

  blurMatcher = new BlurInputErrorMatcher();
  constructor(public dialogRef: MatDialogRef<EditUserInfoComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder) {
    this.userDetails = data.data;
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      username: [null, Validators.required],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      gender: ['Male', Validators.required],
      // dob: [null, Validators.required],
      city: [null, Validators.required],
      country: [null, Validators.required],
      mobile: [null, Validators.required],
      emailId: [null, Validators.required],
      address1: [null, Validators.required],
      address2: [null, Validators.required],
      password: [null],
      conPassword: [null],
      // avatar:[null, Validators.required],
      // internalAddress: [null, Validators.required],
      localeName: [null, Validators.required],
      nemAddress1: [null, Validators.required],
      nemAddress2: [null, Validators.required],
      nemAddress3: [null, Validators.required],
      preferredChart: [null, Validators.required],
      telcode: [null, Validators.required],
      // testAddress: [null, Validators.required],
      userKycDoc: [null, Validators.required],
      userLevel: [null, Validators.required],
      userType: [null, Validators.required],
      zipCode: [null, Validators.required],
      // user2fa: [null, Validators.required],
      // idCompany: [null, Validators.required],
      // idNownumber: [null, Validators.required],




    });
    this.dialogRef.updatePosition({ top: '100px', left: '40%' });
  }

  public onPasswordChange(event: Event) {
    if (this.userDetails.password !== event.target['value']) {
      this.message = 'Enter correct confirmation password!';
      // setTimeout(() => { this.message = 'Enter correct confirmation password!'; }, 200);
    }
    setTimeout(() => {
      this.message = ''
    }, 1000);
  }

  public onClick(status: string): void {
    this.dialogRef.close({
      data: this.userDetails,
      status: status
    });
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/users/edit/edit-user-info.component.ts